import React from 'react';
import './GenericMessage.scss';
import { NotificationSVG } from '../../Member/img/GlobalSVG';

const getIcon = (messageType) => {
  switch (messageType) {
    case 'warning':
      return <NotificationSVG.WarningSVG />;
    case 'success':
      return <NotificationSVG.CheckMarkSVG />;
    case 'info':
      return <NotificationSVG.InformativeSVG />;
    default:
      return <NotificationSVG.InformativeSVG />;
  }
};
const GenericMessage = ({
  title,
  messageType,
  message,
  boldMessage = '',
  showMessage,
  handleOnClose,
  wrapperClasses,
  hideCloseButton,
  dynamicContent = false,
}) =>
  showMessage && (
    <div className={wrapperClasses}>
      <div
        className={`header-banner-msg position-relative mt-3 mb-0 mt-md-0 mb-md-4 ${messageType}`}
      >
        <div className="d-flex flex-row align-items-top">
          {getIcon(messageType)}
          <div role="alert">
            {title && <span>{title}</span>}
            {message &&
              (dynamicContent ? (
                <p
                  dangerouslySetInnerHTML={{
                    __html: message?.trim(),
                  }}
                />
              ) : (
                <p>
                  {boldMessage && <b>{boldMessage}</b>} {message}
                </p>
              ))}
          </div>
        </div>
        {!hideCloseButton && (
          <button
            onClick={handleOnClose}
            type="button"
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        )}
      </div>
    </div>
  );

export default GenericMessage;
